module.exports = __webpack_public_path__ + "static/assets/c6f6100a4392b454a8b5606c72a8ecc6.svg";